import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {EnvService} from "../services/env.service";
import {AuthService} from "../services/auth.service";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {ContactGroupFilter} from "./contactGroup.filter";
import {debounceTime} from "rxjs/operators";
import {SettingsPersistenceService} from "../services/settings-persistence.service";

@Component({
  selector: 'micro-contactGroups',
  templateUrl: './contactGroups.component.html'
})
export class ContactGroupsComponent implements OnInit, OnDestroy {
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  filter: ContactGroupFilter = new ContactGroupFilter();
  isCompanyAdmin: boolean = false;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  pageSettings: SettingsPersistenceService;

  constructor(public auth: AuthService,
              private env: EnvService,
              private http: HttpClient) {
  }

  ngOnInit() {
    this.isCompanyAdmin = this.auth.isCompanyAdmin();
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.contactGroups");
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params: HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator.pageIndex || 0))
      .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize));

    this.http.get(`${this.env.e.url}/auth/contactGroups`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }
}
